import {useEffect} from 'react';

const useToggleStylesheet = (isRTL, isDark, configDispatch) => {
    useEffect(() => {
        document
            .getElementsByTagName('html')[0]
            .setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    }, [isRTL]);

    useEffect(() => {
        document.documentElement.classList[isDark ? 'add' : 'remove']('dark');
        configDispatch({
            type: 'RESET'
        });
    }, [isDark, configDispatch]);
};

export default useToggleStylesheet;
